'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chemist = require('chemist');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _flourishStyle = require('./flourishStyle.scss');

var _flourishStyle2 = _interopRequireDefault(_flourishStyle);

var _akzonobel = require('./assets/akzonobel.svg');

var _akzonobel2 = _interopRequireDefault(_akzonobel);

var _FooterPromotions = require('../../components/FooterPromotions');

var _FooterPromotions2 = _interopRequireDefault(_FooterPromotions);

var _FooterCheckout = require('../../components/FooterPromotions/FooterCheckout');

var _FooterCheckout2 = _interopRequireDefault(_FooterCheckout);

var _Navigation = require('../../components/Navigation');

var _Navigation2 = _interopRequireDefault(_Navigation);

var _localisedPaths = require('../../helpers/localisedPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlourishFooter = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _chemist.configurable)(), _dec3 = (0, _reactCssModules2.default)(_flourishStyle2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(FlourishFooter, _React$Component);

  function FlourishFooter() {
    (0, _classCallCheck3.default)(this, FlourishFooter);
    return (0, _possibleConstructorReturn3.default)(this, (FlourishFooter.__proto__ || (0, _getPrototypeOf2.default)(FlourishFooter)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlourishFooter, [{
    key: 'enclosedCheckout',
    value: function enclosedCheckout() {
      if (!this.props.params.step) {
        return false;
      }

      return this.props.params.step !== 'registration';
    }
  }, {
    key: 'renderPromotions',
    value: function renderPromotions() {
      if (this.props.config.store.code === 'enlflx') {
        return _react2.default.createElement('div', null);
      }

      if (this.props.config.store.code === 'ebelev') {
        return _react2.default.createElement('div', null);
      }

      if (this.props.config.store.code === 'enlwdc') {
        return _react2.default.createElement('div', null);
      }

      if (this.enclosedCheckout()) {
        return _react2.default.createElement(_FooterCheckout2.default, { params: this.props.params });
      }

      return _react2.default.createElement(_FooterPromotions2.default, null);
    }
  }, {
    key: 'renderCopyrightText',
    value: function renderCopyrightText() {
      var t = this.props.t;


      if (this.props.config.store.code === 'eukdlx') {
        return _react2.default.createElement(
          'small',
          { className: 'col-xs-8 t-small t-text--secondary' },
          t('spree.copyright_notice')
        );
      }

      return _react2.default.createElement('div', { className: 'col-xs-8 t-small t-text--secondary' });
    }
  }, {
    key: 'render',
    value: function render() {
      var lng = this.props.params.lng;
      var t = this.props.t;

      var links = [{
        href: (0, _localisedPaths.localisedPath)(this.props.config.store, 'privacyPolicyPath', lng),
        text: t('spree.privacy_policy'),
        class: 'a-link--navigation'
      }, {
        href: (0, _localisedPaths.localisedPath)(this.props.config.store, 'termsConditionsPath', lng),
        text: t('spree.terms_and_conditions.link_text'),
        class: 'a-link--navigation'
      }];

      return _react2.default.createElement(
        'footer',
        { styleName: 'footer' },
        this.renderPromotions(),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { styleName: 'flourishFooter' },
            _react2.default.createElement(_Navigation2.default, { links: links })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'akzoFooter' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              this.renderCopyrightText(),
              _react2.default.createElement(
                'a',
                { href: 'https://www.akzonobel.com', className: 'col-xs-4' },
                _react2.default.createElement('img', {
                  srcSet: _akzonobel2.default,
                  alt: t('akzonobel'),
                  styleName: 'a-akzonobelLogo',
                  className: 'pull-right'
                })
              )
            )
          )
        )
      );
    }
  }]);
  return FlourishFooter;
}(_react2.default.Component), _class2.propTypes = {
  params: _react.PropTypes.object
}, _class2.defaultProps = {
  params: {}
}, _temp)) || _class) || _class) || _class);
exports.default = FlourishFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/Footer/flourish.js
// module id = 2278
// module chunks = 0